import { useEffect, useRef } from 'react';
import { pushCursor } from '../firebase/sync';
import { PALETTE } from '../types';

interface UseCursorOptions {
    sessionId: string;
    uid: string;
    displayName: string;
    /** El SVG ref para convertir coordenadas pantalla → SVG */
    svgRef: React.RefObject<SVGSVGElement | null>;
    /** Color del cursor — se asigna por índice en PALETTE */
    colorIndex?: number;
}

export function useCursor({
    sessionId, uid, displayName, svgRef, colorIndex = 0,
}: UseCursorOptions): void {
    const color = PALETTE[colorIndex % PALETTE.length];
    const enabled = useRef(!!sessionId && !!uid);
    const svgEl = svgRef.current;

    useEffect(() => {
        enabled.current = !!sessionId && !!uid;
    }, [sessionId, uid]);

    useEffect(() => {
        if (!svgEl) return;

        const handler = (e: MouseEvent) => {
            if (!enabled.current) return;

            // Convertir coordenadas de pantalla a espacio SVG
            const r = svgEl.getBoundingClientRect();
            const vb = svgEl.viewBox.baseVal;
            const sx = (e.clientX - r.left) * (vb.width / r.width) + vb.x;
            const sy = (e.clientY - r.top) * (vb.height / r.height) + vb.y;

            pushCursor(sx, sy, displayName, color);
        };

        svgEl.addEventListener('mousemove', handler);
        return () => svgEl.removeEventListener('mousemove', handler);
    }, [svgEl, displayName, color]);
}
